// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from '@mvps-genesis/core';
import Global from 'pages/Global';
// FONTS
import "@fontsource/lato/100.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/lato/900.css";
import "@fontsource/lato/100-italic.css";
import "@fontsource/lato/400-italic.css";
import "@fontsource/lato/700-italic.css";
import "@fontsource/lato/900-italic.css";
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/libre-baskerville/400-italic.css";
import "@fontsource/libre-baskerville/700.css";

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		BASK: () =>	import('./pages/BASK/BASK.js'),
		CPWD: () =>	import('./pages/CPWD/CPWD.js'),
		CTGY: () =>	import('./pages/CTGY/CTGY.js'),
		CTUS: () =>	import('./pages/CTUS/CTUS.js'),
		GFTL: () =>	import('./pages/GFTL/GFTL.js'),
		INVC: () =>	import('./pages/INVC/INVC.js'),
		LOGN: () =>	import('./pages/LOGN/LOGN.js'),
		OCST: () =>	import('./pages/OCST/OCST.js'),
		OPAY: () =>	import('./pages/OPAY/OPAY.js'),
		ORDL: () =>	import('./pages/ORDL/ORDL.js'),
		ORDP: () =>	import('./pages/ORDP/ORDP.js'),
		ORHL: () =>	import('./pages/ORHL/ORHL.js'),
		OSEL: () =>	import('./pages/OSEL/OSEL.js'),
		SFNT: () =>	import('./pages/SFNT/SFNT.js'),
		SRCH: () =>	import('./pages/SRCH/SRCH.js'),
		billpay: () =>	import('./pages/BILLPAY/BILLPAY.js'),
		careers: () =>	import('./pages/Careers/Careers.js'),
		catalog: () =>	import('./pages/Catalog/Catalog.js'),
		history: () =>	import('./pages/history/history.js'),
		tribute: () => import('./pages/tribute/tribute.js'),
		'the-kalahari-dream': () =>	import('./pages/TheKalahariDream/TheKalahariDream.js'),
		WISH: () =>	import('./pages/WISH/WISH.js'),
		WLGN: () =>	import('./pages/WLGN/WLGN.js'),
		WLST: () =>	import('./pages/WLST/WLST.js'),
		'ring-size': () => import('./pages/RingSize/RingSize.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {
		'/^RINGBUILDER/': () =>	import('./pages/RINGBUILDER/RINGBUILDER.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {
		CORPORATE_GIFTS: () =>	import('./pages/Corporate_gifts/Corporate_gifts.js'),
		CTGY_ANCHORS: () =>	import('./pages/CTGY_ANCHORS/CTGY_ANCHORS.js'),
		CTGY_LANDING: () =>	import('./pages/CTGY_LANDING/CTGY_LANDING.js'),
		PROD: () =>	import('./pages/PROD/PROD.js')
	}

});
